import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import routeCodes from 'common/constants/route-codes';

import {
  getRestaurants,
  getRestaurantById,
  resetCurrentRestaurant,
  updateOrCreateRestaurant,
  deleteRestaurantRequest,
  resetErrors,
  resetRestaurantsListData,
  getSelectedRestaurant,
} from './actions';
import {
  restaurantsListData,
  restaurantsListLoading,
  currentRestaurant,
  restaurantErrors,
  deleteInProcessSelector,
  updateOrCreateInProcess,
  restaurantListFetched,
  currentItemInProcessSelector,
} from './selectors';
import { useCommon } from '../common/use-common';
import UIHelper from '../../services/UIHelper';
import { useUser } from '../user/use-user';

export const useRestaurant = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const listData = useSelector(restaurantsListData);
  const listFetched = useSelector(restaurantListFetched);
  const listLoading = useSelector(restaurantsListLoading);
  const deleteInProcess = useSelector(deleteInProcessSelector);

  const handleFetchInitialRestaurants = () => {
    if (!listFetched) {
      dispatch(
        getRestaurants({
          params: {
            per: 10000,
          },
        }),
      );
    }
  };

  const fetchSelectedRestaurant = (params) => {
    dispatch(getSelectedRestaurant(params));
  };

  const handleDeleteRestaurant = (id) => {
    dispatch(deleteRestaurantRequest({ id, history }));
  };

  const resetListData = () => {
    dispatch(resetRestaurantsListData());
  };

  return {
    listData,
    listLoading,
    handleFetchInitialRestaurants,
    handleDeleteRestaurant,
    deleteInProcess,
    resetListData,
    fetchSelectedRestaurant,
  };
};

export const useCurrentRestaurant = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isSuperAdmin } = useUser();
  const restaurant = useSelector(currentRestaurant);
  const errors = useSelector(restaurantErrors);
  const inProcess = useSelector(updateOrCreateInProcess);
  const itemLoading = useSelector(currentItemInProcessSelector);

  const handleGetById = (payload) => {
    dispatch(getRestaurantById(payload));
  };

  const handleResetErrors = () => {
    dispatch(resetErrors());
  };

  const handleResetCurrentRestaurant = () => {
    dispatch(resetCurrentRestaurant());
    dispatch(resetErrors());
  };

  const handleCreateOrUpdate = (
    payload,
    id,
    pushAfterSuccess = routeCodes.profile,
    resetModal = false,
    additionParams = {},
  ) => {
    const { restaurantDisabledAction } = additionParams;
    const afterSuccess = () => {
      if (restaurantDisabledAction) {
        UIHelper.showRestaurantDisableSuccess();
      } else {
        UIHelper.showCreateOrUpdateSuccess();
      }
      if (isSuperAdmin) return;
      history.push(pushAfterSuccess);
    };
    dispatch(
      updateOrCreateRestaurant({
        id,
        formData: payload,
        afterSuccess,
        resetModal,
      }),
    );
  };

  return {
    restaurant,
    handleGetById,
    handleResetCurrentRestaurant,
    handleCreateOrUpdate,
    inProcess,
    errors,
    handleResetErrors,
    itemLoading,
  };
};
